import { useEffect, useState } from "react";

const KEY = "qrdine_cart";
const TABLE_KEY = "qrdine_table";
const RESTO_KEY = "qrdine_cart_restaurant";
const listeners = new Set();

function load() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
let items = load();
const emit = () => listeners.forEach((l) => l(items));

export function useCart() {
  const [s, setS] = useState(items);
  useEffect(() => {
    const l = (v) => setS([...v]);
    listeners.add(l);
    return () => listeners.delete(l);
  }, []);
  return s;
}

const optSig = (i) => [...(i.selected_option_ids || [])].sort().join(",");
export function addItem(item) {
  const sig = optSig(item);
  // Same item with different customization = a separate line.
  const existing = items.find((i) => i.menu_item_id === item.menu_item_id && (i.notes || "") === (item.notes || "") && optSig(i) === sig);
  if (existing) existing.quantity += item.quantity;
  else items.push({ ...item });
  localStorage.setItem(KEY, JSON.stringify(items));
  emit();
}
export function updateQty(idx, qty) {
  if (qty <= 0) items.splice(idx, 1);
  else items[idx].quantity = qty;
  localStorage.setItem(KEY, JSON.stringify(items));
  emit();
}
export function clearCart() {
  items = [];
  localStorage.removeItem(KEY);
  emit();
}
// Drop specific menu_item_ids (e.g. items no longer available on this menu).
export function removeItemsByMenuId(ids) {
  const set = new Set(ids || []);
  items = items.filter((i) => !set.has(i.menu_item_id));
  localStorage.setItem(KEY, JSON.stringify(items));
  emit();
}
// A cart belongs to ONE restaurant. Scanning a different restaurant's table
// starts a fresh cart (its items don't exist on the new menu). Returns true if
// it cleared an existing cart, so the caller can tell the customer.
export function ensureCartRestaurant(rid) {
  if (!rid) return false;
  const cur = localStorage.getItem(RESTO_KEY);
  localStorage.setItem(RESTO_KEY, rid);
  if (cur && cur !== rid && items.length) { clearCart(); return true; }
  return false;
}
export function cartTotal() {
  return items.reduce((sum, i) => sum + i.price * i.quantity, 0);
}
export function cartCount() {
  return items.reduce((s, i) => s + i.quantity, 0);
}

export const tableStore = {
  set(t) { localStorage.setItem(TABLE_KEY, JSON.stringify(t)); },
  get() { try { return JSON.parse(localStorage.getItem(TABLE_KEY) || "null"); } catch { return null; } },
  clear() { localStorage.removeItem(TABLE_KEY); },
};
